var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTemplate = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.2849 2.84961H4.32934C3.93741 2.84961 3.56153 3.0053 3.28439 3.28244C3.00726 3.55958 2.85156 3.93546 2.85156 4.32739V7.28294M7.2849 2.84961H14.6738C15.0657 2.84961 15.4416 3.0053 15.7187 3.28244C15.9959 3.55958 16.1516 3.93546 16.1516 4.32739V7.28294M7.2849 2.84961V16.1496M2.85156 7.28294V14.6718C2.85156 15.0638 3.00726 15.4396 3.28439 15.7168C3.56153 15.9939 3.93741 16.1496 4.32934 16.1496H7.2849M2.85156 7.28294H16.1516M16.1516 7.28294V14.6718C16.1516 15.0638 15.9959 15.4396 15.7187 15.7168C15.4416 15.9939 15.0657 16.1496 14.6738 16.1496H7.2849",
  stroke: "#3E4248",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_template.583abf0e0076aa58b11810f7167b3530.svg";